/* ============================================================
   popguard.js — the first word on every popstate (docs/phone/PHONE-PORT.md §3.5).

   The phone's layers (her thread, the words' page, the drawer, a card) each push a history entry so the phone's own back
   closes them; that back is a popstate the room must take ALONE. vue-router listens on window too, and it would read the pop
   as a navigation: the room's address is "/" written over the router's /listen, so it routes to the front door, which sends a
   member back to /listen with a full load (seen 2026-09-27: every ⌄ reloaded the room on Android, once on iOS).
   Listeners on window run in the order they were added in Chrome before ~117 (capture-first at the target came later), so
   this one is registered at import, BEFORE the router exists (main.ts imports it first), in the capture phase for the newer
   engines too. A handler that says it took the pop stops it there.
   ============================================================ */
let taker = null;

/** The one handler for pops (the phone room's layers): (event) → true when it took this pop. Returns the release. */
export function takePops(fn) {
  taker = fn;
  return () => {
    if (taker === fn) taker = null;
  };
}

if (typeof window === 'object' && window)
  window.addEventListener(
    'popstate',
    (e) => {
      if (taker && taker(e)) e.stopImmediatePropagation();
    },
    true
  );
